var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-button',{attrs:{"variant":_vm.variant,"title":_vm.withText?_vm.withText:'',"icon":_vm.withIcon?'ellipsis-v':'',"size":_vm.size},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }